import React from 'react';
import PropTypes from 'prop-types';
import { vehiculeDataPropType } from "../../../../types/vehiculeTypes";
import "../../VehiculeForm.css";

const DisplayTitulairesNeuf = ({ vehiculeData, readOnly = false }) => {
    return (
        <div className="form-section">
            <div className="section">
            <h3>CERTIFICAT DE VENTE</h3>
            <div className="form-group">
                <label>SOCIÉTÉ:</label>
                <input
                    type="text"
                    value={vehiculeData.vde_1 || ''}
                    readOnly={readOnly}
                    className={readOnly ? "readonly" : ""}
                />
            </div>

            <div className="form-group">
                <label>DATE DE LA VENTE DU VÉHICULE:</label>
                <div className="date-input-group">
                    <div className="date-field">
                        <label>JOUR</label>
                        <input
                            type="text"
                            value={vehiculeData.vde_2_1 || ''}
                            readOnly={readOnly}
                            className={readOnly ? "readonly" : ""}
                        />
                    </div>
                    <div className="date-field">
                        <label>MOIS</label>
                        <input
                            type="text"
                            value={vehiculeData.vde_2_2 || ''}
                            readOnly={readOnly}
                            className={readOnly ? "readonly" : ""}
                        />
                    </div>
                    <div className="date-field">
                        <label>ANNÉE</label>
                        <input
                            type="text"
                            value={vehiculeData.vde_2_3 || ''}
                            readOnly={readOnly}
                            className={readOnly ? "readonly" : ""}
                        />
                    </div>
                </div>
            </div>
            </div>

            <div className="section">
            <h3>IDENTITÉ DU TITULAIRE</h3>
            <div className="radio-group">
                <label>VOUS ÊTES:</label>
                <div className="radio-group-child">
                    <div>
                        <input
                            type="radio"
                            name="tit_1"
                            value="0"
                            checked={vehiculeData.tit_1?.toString() === '0'}
                            readOnly={readOnly}
                        />
                        <label>PERSONNE PHYSIQUE</label>
                    </div>
                    <div>
                        <input
                            type="radio"
                            name="tit_1"
                            value="1"
                            checked={vehiculeData.tit_1?.toString() === '1'}
                            readOnly={readOnly}
                        />
                        <label>PERSONNE MORALE</label>
                    </div>
                </div>
            </div>

            {vehiculeData.tit_1?.toString() === '0' && (
                <>
                    <div className="radio-group">
                        <label>SEXE:</label>
                        <div className="radio-group-child">
                            <div>
                                <input
                                    type="radio"
                                    name="tit_2"
                                    value="0"
                                    checked={vehiculeData.tit_2?.toString() === '0'}
                                    readOnly={readOnly}
                                />
                                <label>MASCULIN</label>
                            </div>
                            <div>
                                <input
                                    type="radio"
                                    name="tit_2"
                                    value="1"
                                    checked={vehiculeData.tit_2?.toString() === '1'}
                                    readOnly={readOnly}
                                />
                                <label>FÉMININ</label>
                            </div>
                        </div>
                    </div>

                    <div className="form-group">
                        <label>NOM DE NAISSANCE ET PRÉNOM:</label>
                        <input
                            type="text"
                            value={vehiculeData.tit_3 || ''}
                            readOnly={readOnly}
                            className={readOnly ? "readonly" : ""}
                        />
                    </div>

                    <div className="form-group">
                        <label>NOM D&apos;USAGE / D&apos;ÉPOUX.SE:</label>
                        <input
                            type="text"
                            value={vehiculeData.tit_4 || ''}
                            readOnly={readOnly}
                            className={readOnly ? "readonly" : ""}
                        />
                    </div>

                    <div className="form-group">
                        <label>NÉ.E LE:</label>
                        <div className="date-input-group">
                            <div className="date-field">
                                <label>JOUR</label>
                                <input
                                    type="text"
                                    value={vehiculeData.tit_5_1 || ''}
                                    readOnly={readOnly}
                                    className={readOnly ? "readonly" : ""}
                                />
                            </div>
                            <div className="date-field">
                                <label>MOIS</label>
                                <input
                                    type="text"
                                    value={vehiculeData.tit_5_2 || ''}
                                    readOnly={readOnly}
                                    className={readOnly ? "readonly" : ""}
                                />
                            </div>
                            <div className="date-field">
                                <label>ANNÉE</label>
                                <input
                                    type="text"
                                    value={vehiculeData.tit_5_3 || ''}
                                    readOnly={readOnly}
                                    className={readOnly ? "readonly" : ""}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="form-group">
                        <label>COMMUNE DE NAISSANCE:</label>
                        <input
                            type="text"
                            value={vehiculeData.tit_6 || ''}
                            readOnly={readOnly}
                            className={readOnly ? "readonly" : ""}
                        />
                    </div>

                    <div className="form-group">
                        <label>DÉPARTEMENT DE NAISSANCE:</label>
                        <input
                            type="text"
                            value={vehiculeData.tit_7 || ''}
                            readOnly={readOnly}
                            className={readOnly ? "readonly" : ""}
                        />
                    </div>

                    <div className="form-group">
                        <label>PAYS DE NAISSANCE:</label>
                        <input
                            type="text"
                            value={vehiculeData.tit_8 || ''}
                            readOnly={readOnly}
                            className={readOnly ? "readonly" : ""}
                        />
                    </div>

                    <div className="form-group">
                        <label>ADRESSE MAIL:</label>
                        <input
                            type="text"
                            value={vehiculeData.tit_9 || ''}
                            readOnly={readOnly}
                            className={readOnly ? "readonly" : ""}
                        />
                    </div>

                    <div className="form-group">
                        <label>N° DE LA VOIE:</label>
                        <input
                            type="text"
                            value={vehiculeData.tit_12 || ''}
                            readOnly={readOnly}
                            className={readOnly ? "readonly" : ""}
                        />
                    </div>

                    <div className="form-group">
                        <label>EXTENSION (BIS, TER, ..):</label>
                        <input
                            type="text"
                            value={vehiculeData.tit_13 || ''}
                            readOnly={readOnly}
                            className={readOnly ? "readonly" : ""}
                        />
                    </div>

                    <div className="form-group">
                        <label>NOM DE LA VOIE:</label>
                        <input
                            type="text"
                            value={vehiculeData.tit_15 || ''}
                            readOnly={readOnly}
                            className={readOnly ? "readonly" : ""}
                        />
                    </div>

                    <div className="form-group">
                        <label>CODE POSTAL:</label>
                        <input
                            type="text"
                            value={vehiculeData.tit_16 || ''}
                            readOnly={readOnly}
                            className={readOnly ? "readonly" : ""}
                        />
                    </div>

                    <div className="form-group">
                        <label>COMMUNE:</label>
                        <input
                            type="text"
                            value={vehiculeData.tit_17 || ''}
                            readOnly={readOnly}
                            className={readOnly ? "readonly" : ""}
                        />
                    </div>

                    
                </>
            )}

            {vehiculeData.tit_1?.toString() === '1' && (
                <>
                    <div className="form-group">
                        <label>RAISON SOCIALE:</label>
                        <input
                            type="text"
                            value={vehiculeData.tit_10 || ''}
                            readOnly={readOnly}
                            className={readOnly ? "readonly" : ""}
                        />
                    </div>

                    <div className="form-group">
                        <label>N° SIRET, LE CAS ÉCHÉANT:</label>
                        <input
                            type="text"
                            value={vehiculeData.tit_11 || ''}
                            readOnly={readOnly}
                            className={readOnly ? "readonly" : ""}
                        />
                    </div>
                </>
            )}
            </div>

            <div className="section">
            <h3>CO-TITULAIRE</h3>
            <div className="radio-group">
                <label>LE VÉHICULE EST-IL DANS UN CAS DE MULTI-PROPRIÉTÉ?</label>
                <div className="radio-group-child">
                    <div>
                        <input
                            type="radio"
                            name="cotit_0"
                            value="1"
                            checked={vehiculeData.cotit_0?.toString() === '1'}
                            readOnly={readOnly}
                        />
                        <label>OUI</label>
                    </div>
                    <div>
                        <input
                            type="radio"
                            name="cotit_0"
                            value="0"
                            checked={vehiculeData.cotit_0?.toString() === '0'}
                            readOnly={readOnly}
                        />
                        <label>NON</label>
                    </div>
                </div>
            </div>

            {vehiculeData.cotit_0?.toString() === '1' && (
                <>
                    <div className="form-group">
                        <label>NOMBRE DE TITULAIRES (C.4.1):</label>
                        <input
                            type="text"
                            value={vehiculeData.cotit_1 || ''}
                            readOnly={readOnly}
                            className={readOnly ? "readonly" : ""}
                        />
                    </div>

                    <div className="radio-group">
                        <label>LE CO-TITULAIRE EST:</label>
                        <div className="radio-group-child">
                            <div>
                                <input
                                    type="radio"
                                    name="cotit_2"
                                    value="0"
                                    checked={vehiculeData.cotit_2?.toString() === '0'}
                                    readOnly={readOnly}
                                />
                                <label>PERSONNE PHYSIQUE</label>
                            </div>
                            <div>
                                <input
                                    type="radio"
                                    name="cotit_2"
                                    value="1"
                                    checked={vehiculeData.cotit_2?.toString() === '1'}
                                    readOnly={readOnly}
                                />
                                <label>PERSONNE MORALE</label>
                            </div>
                        </div>
                    </div>

                    {vehiculeData.cotit_2?.toString() === '0' && (
                        <>
                            <div className="form-group">
                                <label>NOM DE NAISSANCE ET PRÉNOM:</label>
                                <input
                                    type="text"
                                    value={vehiculeData.cotit_3 || ''}
                                    readOnly={readOnly}
                                    className={readOnly ? "readonly" : ""}
                                />
                            </div>

                            <div className="form-group">
                                <label>NOM D&apos;USAGE / D&apos;ÉPOUX.SE:</label>
                                <input
                                    type="text"
                                    value={vehiculeData.cotit_4 || ''}
                                    readOnly={readOnly}
                                    className={readOnly ? "readonly" : ""}
                                />
                            </div>
                        </>
                    )}

                    {vehiculeData.cotit_2?.toString() === '1' && (
                        <div className="form-group">
                            <label>RAISON SOCIALE:</label>
                            <input
                                type="text"
                                value={vehiculeData.cotit_5 || ''}
                                readOnly={readOnly}
                                className={readOnly ? "readonly" : ""}
                            />
                        </div>
                    )}
                </>
            )}
            </div>
        </div>
    );
};

DisplayTitulairesNeuf.propTypes = {
    vehiculeData: vehiculeDataPropType.isRequired,
    readOnly: PropTypes.bool
};

DisplayTitulairesNeuf.defaultProps = {
    readOnly: false
};

export default DisplayTitulairesNeuf;